import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { withNamespaces } from "react-i18next";

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;

    const icons = this.imageImport(
      require.context(
        "../../assets/images/nav",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );

    return (
      <Auxiliary>
        <div className="ps-col">
          <div className="ps-bt-panel">
            <ul className="navbar-nav">
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/dashboard" }}>
                  <img src={icons["dashboard.svg"]} alt="dashboard" />
                  <p>{t('sidebar.dashboard')}</p>
                </NavLink>
              </li>
              <h6>{t('sidebar.member-detail')}</h6>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/management" }}>
                  <img src={icons["management.svg"]} alt="management" />
                  <p>{t('sidebar.management')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/betting-history" }}>
                  <img src={icons["betting-history.svg"]} alt="betting-history" />
                  <p>{t('sidebar.betting-history')}</p>
                </NavLink>
              </li>
              <h6>{t('sidebar.agent-details')}</h6>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/downline-agent" }}>
                  <img src={icons["management.svg"]} alt="downline-agents" />
                  <p>{t('sidebar.downline-agents')}</p>
                </NavLink>
              </li>
              <h6>{t('sidebar.financial-center')}</h6>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/my-wallet" }}>
                  <img src={icons['wallet.svg']} alt="wallet" />
                  <p>{t('sidebar.my-wallet')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/withdrawal" }}>
                  <img src={icons["withdrawal.svg"]} alt="withdrawal" />
                  <p>{t('sidebar.withdraw')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/delegate-deposit" }}>
                  <img src={icons["delegate-deposit.svg"]} alt="delegate-deposit" />
                  <p>{t('sidebar.delegate-deposit')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/deposit" }}>
                  <img src={icons["deposit.svg"]} alt="deposit" />
                  <p>{t('sidebar.deposit')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/financial-report" }}>
                  <img src={icons["financial-report.svg"]} alt="financial-report" />
                  <p>{t("sidebar.financial-report")}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/commission-report" }}>
                  <img src={icons["commision-report.svg"]} alt="commission-report" />
                  <p>{t('sidebar.commission-report')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/transaction-report" }}>
                  <img src={icons["transaction-report.svg"]} alt="transaction-report" />
                  <p>{t('sidebar.transaction-report')}</p>
                </NavLink>
              </li>
              <h6>{t('sidebar.promotion-center')}</h6>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/promote-link" }}>
                  <img src={icons["promote-link.svg"]} alt="promote-link" />
                  <p>{t('sidebar.promote-link')}</p>
                </NavLink>
              </li>
              <h6>{t('sidebar.personal-center')}</h6>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/message-center" }}>
                  <img src={icons["message-center.svg"]} alt="message-center" />
                  <p>{t('sidebar.message-center')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/commision-illustrate" }}>
                  <img src={icons["commision-illustrate.svg"]} alt="commision-illustrate" />
                  <p>{t('sidebar.commission-illustrate')}</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to={{ pathname: "/contact-us" }}>
                  <img src={icons["contact-us.svg"]} alt="contact-us" />
                  <p>{t('sidebar.contact-us')}</p>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </Auxiliary>
    );
  }
}

export default withNamespaces('translation')(SideBar);
